import { properties } from '../properties.js';
import React, { Component } from 'react';
import Web3 from 'web3';
import NavBar from '../navbar.js';
import Footer from '../footer.js';
import i18n from '../I18N/I18n.js'; 
import Cookies from 'js-cookie';
import standard_abi from '../../abis/DPP-abi.json';
import Swal from 'sweetalert2';
import UserCertificateList from './DPPList.js';
import { withTranslation } from 'react-i18next';
import { logout, apiSecuredRequest, setBearer, isUserOrWallet, isRootWallet} from '../functions.js';



class DPPListComponent extends Component {

    async componentDidMount() {
        // 1. Carga de Web3
        const bearer = await this.checkIfWeb3UserOrLoginUser();
        await this.loadUserCertificates(bearer);
       
        // 2. Carga de datos de la Blockchain

      //  await this.cargarCamposMarca()
    }

    async checkIfWeb3UserOrLoginUser() { 
        let params = (new URL(document.location)).searchParams;
        this.setState({saleDate: new Date()})
        const certificadoId = params.get("certificadoId");
        this.setState({ certificadoId: certificadoId })
        const certificadoName = params.get("certificadoName");
        this.setState({certificadoName})
      
        
        const email = Cookies.get("email");
        this.setState({ email: email });
        
        const bearer = Cookies.get("id");
        this.setState({ bearer: bearer });
        const userRol = Cookies.get("rol");
        this.setState({ userRol: userRol });
        let bearerVar;
        const urlInfo = window.location.pathname.split("/")
       
        this.setState({ empresaMapping: urlInfo[1] })
        
        bearerVar = Cookies.get("id");
        let account = await isUserOrWallet(email, bearerVar);
        const isRootDir = await isRootWallet(account);
        this.setState({isRootDir: isRootDir});

        this.setState({account})
        const bearerToken = await setBearer(email, bearerVar, account);
        this.setState({bearer: bearerToken})
        return bearerToken;
    }

    cambiarIdioma = (idioma) => {
			const { i18n } = this.props;
			i18n.changeLanguage(idioma);
			Cookies.set('idiomaPreferido', idioma, { expires: 365 }); // Guarda la preferencia por un año // Cambia el idioma usando i18n
		};
    logout = async () => {
        this.setState({bearer: null});
        this.setState({email: null});
        logout();
    }
    
    
    async loadUserCertificates(bearer) {

		
		let web3;
		const abi = standard_abi
		const certificado = JSON.parse(localStorage.getItem('certificado'));
		const direccion = certificado.direccion;
		this.setState({direccion: direccion})
		
		let userNfts;
		let balance;
		if(abi && direccion) {

			
			try{
				
				if(this.state.account != 0) {
					web3 = window.web3;
					const contractA = new web3.eth.Contract(abi, direccion)
					this.setState({ contract: contractA })

					// METAMASK

					this.setState({ contract: contractA })
					const networkId = await web3.eth.net.getId();
					const userNfts = await contractA.methods.getAllStandardData().call({ from: this.state.account })
					const balance = userNfts.length
					this.setState({ userNfts })
					this.setState({ balance })


				}else{

                    
					const usuario = JSON.parse(localStorage.getItem('usuario'));
					const userId = usuario.id;
					 web3 = new Web3(new Web3.providers.HttpProvider(properties.web3Provider));
					 const contractA = new web3.eth.Contract(abi, direccion)
					//LOG IN
					const apiUserNfts = await apiSecuredRequest("get", `${properties.apiUrl}/certificat/api/standardData/standardInfo/getByUseridAndCertificadoId/${userId}/${certificado.id}/DPP16`, "", bearer);
		
					this.setState({ dataBaseNfts: apiUserNfts.data })

					const corporativeWalletNfts = await contractA.methods.getAllStandardData().call({ from: properties.proofUHostWallet })
					let userNfts = []
					for (let x = 0; x < this.state.dataBaseNfts.length; x++) {
						for (let i = corporativeWalletNfts.length - 1; i >= 0; i--) {
							if (corporativeWalletNfts[i].idLinea == this.state.dataBaseNfts[x].idProducto) {


									userNfts.push(corporativeWalletNfts[i]);
                                    break;

							}

						}

					}

					const balance = userNfts.length
					this.setState({ userNfts })
					this.setState({ balance })
					
				}
			}catch (err) {
				this.setState({ errorMessage: err })
			}
		}else{
			Swal.fire({
				title: `${i18n.t('certificatesError')}`,
				icon: 'error',
				showCancelButton: false,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "OK"
				}).then((result) => {
					if (result.isConfirmed) {
						window.locationbar.href = "/"
					}else  if(result.dismiss){
						window.locationbar.href = "/"
					}
				 
				})
			  window.locationbar.href = "/"
			

		}

		

	}

    constructor(props) {
		super(props)
		this.state = {
			account: '0x0',
			loading: true,
			contract: null,
			balance: null,
			userNfts: null,
			email: null,
			userId: null,
			bearer: null,
			certificadoId: null,
			certificadoName: null,
			dataBapostgreNfts: null,
			empresaMapping: null
		}
	}



    render() {

		return (
			<>
				 <NavBar mail={this.state.email} bearer={this.state.bearer} logout={this.logout} cambiarIdioma={this.cambiarIdioma} />

				<main >

				<div className="buttonContainer">
					
						<button onClick={(event) => { window.location.href = `/listaEmpresas` }}  className="cewy-button-link cewy-button-left" >{i18n.t('backToEnterprise')}</button>
						<button className="cewy-button-link cewy-button-right"  onClick={(event) => { window.location.href = `/${this.state.empresaMapping}/DPP16/DPPGenerator?certificadoId=${this.state.certificadoId}&certificadoName=${this.state.certificadoName}` }} >
        {i18n.t('newDPP')}
    </button>    
				</div>

				<h1 className="centeredTitle">{this.state.empresaName}</h1>
					<UserCertificateList items={this.state.userNfts} balance={this.state.balance} contract={this.state.contract}
						mail={this.state.email} id={this.state.bearer} account={this.state.account} mapping = {this.state.empresaMapping} certificadoId ={this.state.certificadoId} certificadoName = {this.state.certificadoName} />

				</main>
				<Footer />

			</>

		);
	}



}export default withTranslation()(DPPListComponent);